WiseMetering.Model.Organization = WiseMetering.Model.extend({
    urlRoot: '/organizations',

    calculateRequests: function(type) {
        let total = 0;
        WiseMetering.apiRequests.forEach(function(request) {
            let startOf = moment.tz(this.get('timezone')).startOf(type).unix();
            if (request.get('day') >= startOf) {
                total = total + request.get('counter');
            }
        }.bind(this));
        return total;
    },

    dataRetention: function() {
        const plan = this.plan();
        return plan.get('data_retention');
    },

    defaults: function() {
        return {
            automation: false,
            country_code: 'PT',
            currency: '€',
            name: '',
            sets: false,
            subdomain: '',
            timezone: 'Europe/Lisbon'
        };
    },

    getAllowedTransitions: function() {
        const slug = this.plan().get('slug');

        return {
            free: true,
            essentials: ['free'].includes(slug),
            standard: ['free', 'essentials'].includes(slug),
            advanced: ['free', 'essentials', 'standard'].includes(slug),
            premium: ['free', 'essentials', 'standard', 'advanced'].includes(slug)
        };
    },

    hasSpecialFeatures: function() {
        return this.get('type') !== 'retail';
    },

    icon: function() {
        return 'organization';
    },

    isSite: function() {
        return this.get('type') === 'site';
    },

    isPlan: function(slug) {
        return this.get('plan_id') === WiseMetering.plans.findWhere({ slug })?.id;
    },

    isRetail: function() {
        return this.get('type') === 'retail';
    },

    showIntegrations: function() {
        return WiseMetering.currentOrganization.get('has_integrations');
    },

    subdomain: function() {
        return '/' + this.get('subdomain');
    },

    plan: function() {
        return WiseMetering.plans.get(this.get('plan_id'));
    },

    showControlOutputs: function() {
        return this.get('automation') || this.get('type') === 'retail';
    }
});
